// extracted by mini-css-extract-plugin
export default {"chip":"ReasonChip_chip__eyrAe","scopeTag":"ReasonChip_scopeTag__AROZo"};